<template>
  <div id="receive">
    <mt-header fixed :title="title">
      <mt-button
        icon="back"
        slot="left"
        @click.native="$router.back()"
      ></mt-button>
      <!-- <mt-button slot="right">
              <img src="../../assets/img/coinDetail/ico_fenxiang_shoukuan.png" alt="" class="sao">
          </mt-button> -->
    </mt-header>
    <div class="content">
      <!-- <div ref="qrCodeUrl" id="qrcode" class="erQur"></div> -->
      <div
        v-if="$route.query.category === 'HD'"
        id="qrcode"
        class="erQur"
      ></div>
      <img v-else v-bind:src="cataData.qr_code_url" alt="" class="erQur" />
      <!-- <template v-if="$route.query.category !== 'HD'">
        <p
          class="address wx_fontSize3 wx_one_ellipsis"
          style="color: #0191f5"
          @click="backupTip()"
        >
          {{ $t("设置收款金额") }}
        </p>
        <p class="address wx_fontSize1 tip">
          {{ $t("收款金额") }}：{{ coinSymbol }}{{ display_coin_symbol }} ≈
          {{ currency }}{{ currency_char }}{{ cataData.price }}
        </p>
      </template> -->
      <div class="copywrap">
        <p class="address wx_fontSize3 wx_one_ellipsis">
          {{ cataData.address }}
        </p>
        <div class="copydetail" @click="copy($event, cataData.address)">
          <img src="@/assets/img/ico_fuzhi_bzxq_hui.png" width="20px" />
        </div>
        <!-- <svg t="1657678375283" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2264" width="18" height="18"><path d="M576 384a64 64 0 0 1 64 64v341.333333a64 64 0 0 1-64 64H234.666667a64 64 0 0 1-64-64V448a64 64 0 0 1 64-64h341.333333z m0 64H234.666667v341.333333h341.333333V448z m-64 192v64H298.666667v-64h213.333333zM789.333333 170.666667a64 64 0 0 1 64 64v341.333333a64 64 0 0 1-64 64h-106.666666v-64h106.666666V234.666667H448v106.666666h-64v-106.666666a64 64 0 0 1 64-64h341.333333zM512 533.333333v64H298.666667v-64h213.333333z" p-id="2265"></path></svg> -->
      </div>
      <div class="footer wx_fontSize3" @click="saveImage">
        {{ $t("保存收款码") }}
      </div>
      <p class="tip wx_fontSize1 margin-big-top">{{ cataData.tips }}</p>
    </div>
    <div class="box" v-show="isShow">
      <div class="message">
        <div class="swiper" style="color: #212519">
          <p class="wx_fontSize4">{{ $t("设置收款金额") }}</p>
        </div>
        <div class="addressed">
          <input
            type="text"
            :placeholder="$t('请输入数值')"
            class="wx_one_ellipsis wx_fontSize3"
            style="width: 80%"
            v-model="coinSymbol"
            value="coinSymbol"
          />
          <!-- <span class="fuhao">{{coin_symbol}}</span> -->
          <!-- <input type="text" placeholder="0 CNY" class="wx_one_ellipsis wx_fontSize3 contact" style="width:40%" v-model="currency" value="currency"> -->
        </div>
        <ul class="wx_fontSize3 know clearfix">
          <li class="wx_fontSize2" @click="backupTip()">{{ $t("取消") }}</li>
          <li class="wx_fontSize2" @click="markTip()">{{ $t("确定") }}</li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import handleClipboard from "@/utils/clipboard";
import { Toast } from "mint-ui";
import QRCode from "qrcodejs2";
import { httpAddress, httpAccountHDAddress } from "@/api/index";
import { httpCoinDetail } from "@/api/hdwallet";
export default {
  data() {
    return {
      title: "",
      isShow: false,
      coinSymbol: 0,
      coin_symbol: "",
      display_coin_symbol: "",
      cataData: {},
      currency_char: "",
      currency: "",
      hdCoinInfo: {},
    };
  },
  mounted() {},
  activated() {
    this.title =this.$t("收款地址");
    this.coin_symbol = this.$route.query.coin_symbol;
    this.display_coin_symbol = this.$route.query.display_coin_symbol;
    this.currency_char = this.$store.state.currency_char;
    this.currency = this.$store.state.currency;
    this.network = this.$route.query.network;
    this.coin = this.$route.query.coin;
    this.Address();
  },
  methods: {
    Address() {
      if (this.$route.query.category == "云端") {
        httpAddress({
          coin_symbol: this.$route.query.coin_symbol,
          amount: this.coinSymbol,
          currency: this.$store.getters.currency,
          network: this.network,
          coin: this.coin,
        })
          .then((res) => {
            this.cataData = [];
            this.cataData = res.data;
          })
          .catch(() => {});
      } else if (this.$route.query.category == "HD") {
        /* httpAccountHDAddress({coin_symbol:this.$route.query.coin_symbol,amount:this.coinSymbol,currency:this.$store.getters.currency})
        .then(res => {
          this.cataData = [];
          this.cataData = res.data;
        })
        .catch(() => {}); */
        httpCoinDetail({ symbolId: this.$route.query.symbolId }).then(
          ({ result }) => {
            this.hdCoinInfo = result;
            var qrcode = new QRCode("qrcode", {
              text: result.address,
              width: 220,
              height: 220,
              colorDark: "#000000",
              colorLight: "#ffffff",
              correctLevel: QRCode.CorrectLevel.H,
            });
          }
        );
      }
    },
    copy: function (event, val) {
      if (this.$route.query.category === "HD") {
        val = this.hdCoinInfo.address;
      }
      handleClipboard(
        val,
        event,
        () => {
          Toast(this.$t("fuzhicg"));
        },
        () => {
          Toast(this.$t("fuzhicc"));
        }
      );
    },
    backupTip() {
      this.isShow = !this.isShow;
    },
    markTip() {
      this.Address();
      this.isShow = !this.isShow;
    },
    saveImage() {
      const a = document.createElement("a");
      if (this.$route.query.category === "HD") {
        a.href = document.querySelector("#qrcode img").getAttribute("src");
      } else {
        a.href = this.cataData.qr_code_url;
      }
      a.download = "qrcode";
      const event = new MouseEvent("click");
      a.dispatchEvent(event);
    },
  },
};
</script>

<style scoped>
#against {
  width: 100%;
  height: 100%;
}
.mint-header {
  background: #ffffff;
  color: #212529;
  border-bottom: 1px solid #e3e8ed;
}
.mint-button--default {
  color: #656b79 !important;
}
.sao {
  width: 20px;
  height: 20px;
}
.content {
  height: 100%;
  padding: 60px 15px 0 15px !important;
}
.erQur {
  width: 220px;
  height: 220px;
  margin-top: 36px;
  /* margin-left: calc(50% - 110px); */
  border: 6px solid #dfeeff;
}
.copywrap {
  /* margin-top: 15px; */
  width: calc(100% - 20px);
  display: flex;
  align-items: center;
  margin: 15px 0 auto;
  justify-content: space-between;
}
.address {
  color: #212529;
  width: 80%;
  height: 31px;
  text-align: left;
  word-break: break-all;
  /* white-space: nowrap; */
  /* overflow: hidden; */
  /* text-overflow: ellipsis;
  overflow: inherit; */
  text-overflow: ellipsis;
}
.footer {
  width: calc(100% - 20px);
  height: 50px;
  background: #1296db;
  line-height: 50px;
  text-align: center;
  color: #ffffff;
  margin-top: 22px;
  border-radius: 0px;
  /* margin-left: 10px; */
}
.tip {
  width: 100%;
  color: #8c8686;
  text-align: center;
}
.margin-big-top {
  margin-top: 20px;
}
.box {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.4);
  z-index: 5;
  width: 100%;
  height: 100%;
}
.message {
  width: 100%;
  background: #fff;
  border-radius: 5px;
  position: fixed;
  bottom: 0;
  border-top: 1px solid #eee;
}
.eys {
  width: 60px;
  height: 60px;
  margin-left: calc(50% - 30px);
  margin-top: 20px;
}
.know {
  color: #e40848;
  font-weight: bold;
  width: 50px;
  width: calc(100% - 30px);
  line-height: 50px;
  border-radius: 4px;
  margin-left: 15px;
  position: relative;
  bottom: 13px;
  background: #f6f6f6;
  margin-top: 20px;
}
.know li {
  float: left;
  width: 50%;
  height: 100%;
  text-align: center;
  color: #8c92a8;
}
.swiper {
  box-sizing: border-box;
  border-radius: 10px;
  color: #fff;
  padding: 10px;
  box-sizing: border-box;
}
.swiper p {
  margin: 15px 5px;
}
.addressed {
  height: 50px;
  line-height: 50px;
  border-top: 1px solid #e3e8ed;
  width: 100%;
  color: #a9afc8;
  position: relative;
  box-sizing: border-box;
  padding: 0 20px;
}
.addressed input {
  width: 60%;
  height: 50px;
  line-height: 50px;
}
.fuhao {
  height: 26px;
  position: absolute;
  left: 45%;
  bottom: 13px;
  line-height: 26px;
  color: #212529;
}
.contact {
  height: 26px;
  position: absolute;
  right: 0px;
  bottom: -1px;
  line-height: 26px;
  color: #212529;
}
.content {
  padding: 40px 10px 0 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.wx_fontSize3 {
  font-size: 14px;
}
.copydetail {
  position: relative;
  top: 0px;
  right: 0px;
}
.wx_one_ellipsis {
  display: block;
}
</style>
